import {useContext} from 'solid-js'
import {RemoteInputContext} from './RemoteInputContext'
import {RemoteInputProviderBehavior} from './RemoteInputProvider'

export function useRemoteInput() {
    const contextValue: RemoteInputProviderBehavior = useContext(RemoteInputContext)
    if (!contextValue) {
        throw new Error(
            'could not find redux context value; please ensure the component is wrapped in a <ReduxProvider>'
        )
    }
    return contextValue
}
